import { j as jsxRuntimeExports } from "../../jsx-runtime-9d42c573.js";
import { memo, useState, useMemo, useCallback } from "react";
import { ImgLoadStatus } from "./constants/constants.js";
import switchDomain from "./utils/switchDomain-v2.js";
import { getCroppedImageUrl } from "./utils/getCroppedImageUrl.js";
import CroppedImageContainer from "./components/container.js";
import ImageComp from "./components/imageComp.js";
import BgImage from "./components/bg-image.js";
import useCdnConfigContext from "./context/useCdnConfigContext.js";
import "url-parse";
import "./utils/tools.js";
import "./utils/getDevicePixelRatio.js";
import "./constants/imageStandards.js";
import "react-intersection-observer";
import "tailwind-merge";
import "./components/placeholder.js";
import "./hooks/useLoadImage.js";
import "./components/basic-bg-image.js";
import "goober";
import "./context/CdnConfigContext.js";
const _CroppedImage = (props) => {
  const {
    type = "img",
    url,
    width,
    height,
    className = "",
    style = {},
    wrapperClassName = "",
    wrapperStyle = {},
    alt,
    lazyLoad,
    lazyLoadConfigs = {},
    adaptDomain = true,
    configs = {},
    showLoadingPlaceholder,
    placeholder = null,
    showErrorPlaceholder,
    errorPlaceholder = null,
    loadingPlaceholderClassName = "",
    errorPlaceholderClassName = "",
    onLoad,
    onError,
    ...rest
  } = props;
  const [imgLoadStatus, setImgLoadStatus] = useState(
    type === "img" ? ImgLoadStatus.loading : ImgLoadStatus.loaded
  );
  const { cdnSwitchMap } = useCdnConfigContext();
  const [resetUrl, setResetUrl] = useState(false);
  const imgUrl = useMemo(() => {
    if (adaptDomain && !resetUrl) {
      const imageUrl = switchDomain(url, cdnSwitchMap);
      return getCroppedImageUrl(imageUrl, { devicePixelRatio: 2, ...configs });
    }
    return getCroppedImageUrl(url, { devicePixelRatio: 2, ...configs });
  }, [adaptDomain, resetUrl, url, configs, cdnSwitchMap]);
  const imgUrlSet = useMemo(() => {
    let _url = url;
    if (adaptDomain && !resetUrl) {
      _url = switchDomain(url, cdnSwitchMap);
    }
    const url_1x = getCroppedImageUrl(_url, { devicePixelRatio: 1, ...configs });
    const url_2x = imgUrl;
    const url_3x = imgUrl;
    return [url_1x, url_2x, url_3x];
  }, [url, adaptDomain, resetUrl, configs, imgUrl, cdnSwitchMap]);
  const sendImageLoadErrorLog = useCallback(() => {
    var _a;
    if (window == null ? void 0 : window.raptor) {
      (_a = window == null ? void 0 : window.raptor) == null ? void 0 : _a.reportLogs({
        fn: "CroppedImage image loaded error",
        params: {
          url: imgUrl,
          type
        }
      });
    }
  }, [imgUrl, type]);
  const handleImgLoad = useCallback(
    (event) => {
      setImgLoadStatus(ImgLoadStatus.loaded);
      onLoad == null ? void 0 : onLoad(event);
    },
    [onLoad]
  );
  const handleImgLoadError = useCallback(
    (event) => {
      sendImageLoadErrorLog();
      setImgLoadStatus(ImgLoadStatus.loadError);
      setResetUrl(true);
      onError == null ? void 0 : onError(event);
    },
    [onError, sendImageLoadErrorLog]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CroppedImageContainer,
    {
      imgLoadStatus,
      lazyLoad,
      lazyLoadConfigs,
      wrapperClassName,
      wrapperStyle,
      className,
      showLoadingPlaceholder,
      showErrorPlaceholder,
      placeholder,
      errorPlaceholder,
      loadingPlaceholderClassName,
      errorPlaceholderClassName,
      children: type === "img" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        ImageComp,
        {
          url: imgUrl,
          urlSet: imgUrlSet,
          className,
          width,
          height,
          style,
          alt,
          onLoad: handleImgLoad,
          onError: handleImgLoadError,
          ...rest
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        BgImage,
        {
          url: imgUrl,
          urlSet: imgUrlSet,
          className,
          width,
          height,
          style,
          onLoad: handleImgLoad,
          onError: handleImgLoadError,
          ...rest
        }
      )
    }
  );
};
const CroppedImage = memo(_CroppedImage);
export {
  CroppedImage as default
};
//# sourceMappingURL=index.js.map
